// extracted by mini-css-extract-plugin
export default {"fs":"_90b6a6dee6 d351bfaf3d"};